import { Action } from 'redux';
import { OpenedFrom } from '@/lib/gTagManager';
import { DrawerName } from '@/store/ui/reducers';

export enum UIActionType {
  SetIsSingleGame = 'UI_SET_IS_SINGLE_GAME',
  SetLoginOpenedFrom = 'UI_SET_LOGIN_OPENED_FROM',
  SetRegistrationOpenedFrom = 'UI_SET_REGISTRATION_OPENED_FROM',
  SetPhotoIdScanModalSeen = 'UI_PHOTO_ID_SCAN_MODAL_SEEN',
  SetSearchDisplayed = 'SET_SEARCH_DISPLAYED',
  IsSearchDisplayed = 'IS_SEARCH_DISPLAYED',
  SetSearchValue = 'SEARCH_VALUE',
  OpenDrawer = 'OPEN_DRAWER',
  CloseDrawer = 'CLOSE_DRAWER',
}

export type SetIsSingleGameAction = Action<UIActionType.SetIsSingleGame> & {
  isSingleGame: boolean;
};

export type SetRegistrationOpenedFromAction = Action<UIActionType.SetRegistrationOpenedFrom> & {
  openedFrom: OpenedFrom;
};

export type SetLoginOpenedFromAction = Action<UIActionType.SetLoginOpenedFrom> & {
  openedFrom: OpenedFrom;
};

export type SetPhotoIdScanModalSeen = Action<UIActionType.SetPhotoIdScanModalSeen> & {
  photoIdScanModalSeen: boolean;
};

export type OpenDrawerAction = Action<UIActionType.OpenDrawer> & {
  drawerName: DrawerName;
};
export type CloseDrawerAction = Action<UIActionType.CloseDrawer>;

export type SetSearchDisplayedAction = Action<UIActionType.SetSearchDisplayed> & {
  displayed: boolean;
};
export type IsSearchDisplayedAction = Action<UIActionType.IsSearchDisplayed>;
export type SetSearchValueAction = Action<UIActionType.SetSearchValue> & {
  searchValue: string;
};

export type Actions =
  | SetIsSingleGameAction
  | SetRegistrationOpenedFromAction
  | SetLoginOpenedFromAction
  | SetPhotoIdScanModalSeen
  | OpenDrawerAction
  | CloseDrawerAction
  | SetSearchValueAction
  | SetSearchDisplayedAction
  | IsSearchDisplayedAction;

export const setIsSingleGame = (isSingleGame: boolean): SetIsSingleGameAction => ({
  type: UIActionType.SetIsSingleGame,
  isSingleGame,
});

export const setRegistrationOpenedFrom = (
  openedFrom: OpenedFrom,
): SetRegistrationOpenedFromAction => ({
  type: UIActionType.SetRegistrationOpenedFrom,
  openedFrom,
});

export const setLoginOpenedFrom = (openedFrom: OpenedFrom): SetLoginOpenedFromAction => ({
  type: UIActionType.SetLoginOpenedFrom,
  openedFrom,
});

export const setPhotoIdScanModalSeen = (
  photoIdScanModalSeen: boolean,
): SetPhotoIdScanModalSeen => ({
  type: UIActionType.SetPhotoIdScanModalSeen,
  photoIdScanModalSeen,
});

export const openDrawer = (drawerName: DrawerName) => ({
  type: UIActionType.OpenDrawer,
  drawerName,
});

export const closeDrawer = () => ({
  type: UIActionType.CloseDrawer,
});

export const setSearchDisplayed = (displayed: boolean) => ({
  type: UIActionType.SetSearchDisplayed,
  displayed,
});

export const setSetSearchValue = (searchValue: string) => ({
  type: UIActionType.SetSearchValue,
  searchValue,
});
